import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrossSmall = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.74999 6.68933L12 10.9393L16.25 6.68933L17.3107 7.74999L13.0607 12L17.3107 16.25L16.25 17.3107L12 13.0607L7.74999 17.3107L6.68933 16.25L10.9393 12L6.68933 7.74999L7.74999 6.68933Z",
		fill: "currentcolor"
	})]
});
export default SvgCrossSmall;
